import React from 'react';
import './FollowButtonAtom.scss';

export interface FollowButtonAtomProps {
  isFollowed: boolean;
  followerCount?: number;
  loading?: boolean;
  onClick: () => void;
  /** Pre-translated "Follow" label */
  followLabel?: string;
  /** Pre-translated "Following" label */
  followingLabel?: string;
  className?: string;
}

const FollowButtonAtom: React.FC<FollowButtonAtomProps> = ({
  isFollowed,
  followerCount,
  loading = false,
  onClick,
  followLabel = 'Follow',
  followingLabel = 'Following',
  className = '',
}) => {
  const classes = [
    'marketplace-follow-btn',
    isFollowed ? 'marketplace-follow-btn--following' : 'marketplace-follow-btn--not-following',
    loading ? 'marketplace-follow-btn--loading' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      disabled={loading}
      aria-pressed={isFollowed}
    >
      {loading ? (
        <i className="pi pi-spinner pi-spin marketplace-follow-btn__icon" aria-hidden="true" />
      ) : isFollowed ? (
        <i className="pi pi-heart-fill marketplace-follow-btn__icon" aria-hidden="true" />
      ) : (
        <i className="pi pi-heart marketplace-follow-btn__icon" aria-hidden="true" />
      )}
      <span className="marketplace-follow-btn__label">
        {isFollowed ? followingLabel : followLabel}
      </span>
      {followerCount !== undefined && (
        <span className="marketplace-follow-btn__count" aria-label={`${followerCount} followers`}>
          {followerCount}
        </span>
      )}
    </button>
  );
};

FollowButtonAtom.displayName = 'FollowButtonAtom';

export default FollowButtonAtom;
